import { Flex, Text, CloseIcon, IconButton, InjectedModalProps } from 'vvs-uikit'
import type { History } from 'history'
import GotchiActionButton from 'views/VvsGotchi/components/ActionButton'
import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'
import { useTranslation } from 'contexts/Localization'
import { formatUrlSearch } from 'utils/urlSearch'
import { Search } from 'config/constants/paths'

import { GachaponModalFlex, ModalTitleFlex, ModalCloseButton } from './styles'

const GachaponPopupModal: React.FC<
  InjectedModalProps & {
    history: History
  }
> = ({ onDismiss, history }) => {
  const { t } = useTranslation()

  return (
    <GachaponModalFlex>
      <ModalTitleFlex p={3} bg="yellow">
        <ModalCloseButton>
          <IconButton variant="text" onClick={onDismiss}>
            <CloseIcon fill="black" />
          </IconButton>
        </ModalCloseButton>

        <Flex mt={4} mb={3} justifyContent="center" alignItems="center" gap="20px">
          <PixelatedImage src="/images/vvsGotchi/tableware.png" width="18px" />
          <Text color="black" fontSize="28px" fontWeight="600">
            {t('+')}
          </Text>
          <PixelatedImage src="/images/vvsGotchi/flag.png" width="24px" />
          <Text color="black" fontSize="28px" fontWeight="600">
            {t('=')}
          </Text>
          <PixelatedImage src="/images/vvsGotchi/gachapon-icon.png" width="34px" />
        </Flex>
      </ModalTitleFlex>
      <Flex p={3} flexDirection="column">
        <Text mb={2} color="black" fontSize="20px" fontWeight="600">
          {t('Hey! A lucky draw to win special prizes is waiting for you!')}
        </Text>
        <Text
          mb={3}
          color="black"
          fontWeight="500"
          dangerouslySetInnerHTML={{
            __html: t('Complete daily missions to <b>unlock this</b>'),
          }}
        />
        <GotchiActionButton
          mt={2}
          onClick={() => {
            onDismiss()
            history.replace({
              search: formatUrlSearch(Search.VVS_GOTCHI_GACHAPON),
            })
          }}
        >
          {t('Go to Lucky Draw')}
        </GotchiActionButton>
      </Flex>
    </GachaponModalFlex>
  )
}

export default GachaponPopupModal
